/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CommercialConditionsRequest,
  CommercialConditionsResponse,
  DiscountAndPayment,
  GoogleDriveFilePointer,
  OrganizationCompetitorInventoryVisibilityResponse,
  OrganizationDetailsResponse,
  OrganizationRequest,
  OrganizationRequestDataWithFiles,
  OrganizationResponse,
  OrganizationUpdateCompetitorInventoryVisibility,
  OrganizationUpdateCover,
  OrganizationUpdateName,
  OrganizationUpdateTenants,
  PageResponseOrganizationDetailsResponse,
  PageResponseOrganizationResponse,
  PostgresFilePointer,
  S3FilePointer,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Organizations<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags private-organization-controller
   * @name AddOrganization
   * @request POST:/organizations
   * @secure
   * @response `200` `OrganizationResponse` OK
   */
  addOrganization = (
    data: OrganizationRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponse, any>({
      path: `/organizations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name SignupRequests
   * @request POST:/organizations/signupRequests
   * @secure
   * @response `200` `PageResponseOrganizationDetailsResponse` OK
   */
  signupRequests = (data: OrganizationRequest, params: RequestParams = {}) =>
    this.request<PageResponseOrganizationDetailsResponse, any>({
      path: `/organizations/signupRequests`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name ApproveOrganization
   * @request POST:/organizations/signupRequests/{organizationId}/approvals
   * @secure
   * @response `200` `OrganizationDetailsResponse` OK
   */
  approveOrganization = (organizationId: string, params: RequestParams = {}) =>
    this.request<OrganizationDetailsResponse, any>({
      path: `/organizations/signupRequests/${organizationId}/approvals`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name DenyOrganization
   * @request DELETE:/organizations/signupRequests/{organizationId}/approvals
   * @secure
   * @response `200` `OrganizationDetailsResponse` OK
   */
  denyOrganization = (organizationId: string, params: RequestParams = {}) =>
    this.request<OrganizationDetailsResponse, any>({
      path: `/organizations/signupRequests/${organizationId}/approvals`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name AllOrganizations
   * @request POST:/organizations/getOrganizations
   * @secure
   * @response `200` `PageResponseOrganizationResponse` OK
   */
  allOrganizations = (data: OrganizationRequest, params: RequestParams = {}) =>
    this.request<PageResponseOrganizationResponse, any>({
      path: `/organizations/getOrganizations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name UpdateOrganizationTenants
   * @request PATCH:/organizations/{organizationId}/tenants
   * @secure
   * @response `200` `OrganizationDetailsResponse` OK
   */
  updateOrganizationTenants = (
    organizationId: string,
    data: OrganizationUpdateTenants,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationDetailsResponse, any>({
      path: `/organizations/${organizationId}/tenants`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name UpdateOrganizationName
   * @request PATCH:/organizations/{organizationId}/name
   * @secure
   * @response `200` `OrganizationResponse` OK
   */
  updateOrganizationName = (
    organizationId: string,
    data: OrganizationUpdateName,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponse, any>({
      path: `/organizations/${organizationId}/name`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags public-organization-controller
   * @name UpdateOrganizationDiscounts
   * @request PATCH:/organizations/{organizationId}/discounts
   * @secure
   * @response `200` `OrganizationDetailsResponse` OK
   */
  updateOrganizationDiscounts = (
    organizationId: string,
    data: DiscountAndPayment,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationDetailsResponse, any>({
      path: `/organizations/${organizationId}/discounts`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name GetOrganizationCover
   * @request GET:/organizations/{organizationId}/cover
   * @secure
   * @response `200` `File` OK
   */
  getOrganizationCover = (organizationId: string, params: RequestParams = {}) =>
    this.request<Blob, any>({
      path: `/organizations/${organizationId}/cover`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name DeleteOrganizationCover
   * @request DELETE:/organizations/{organizationId}/cover
   * @secure
   * @response `200` `(GoogleDriveFilePointer | PostgresFilePointer | S3FilePointer)` OK
   */
  deleteOrganizationCover = (
    organizationId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      GoogleDriveFilePointer | PostgresFilePointer | S3FilePointer,
      any
    >({
      path: `/organizations/${organizationId}/cover`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name UpdateOrganizationCover
   * @request PATCH:/organizations/{organizationId}/cover
   * @secure
   * @response `200` `File` OK
   */
  updateOrganizationCover = (
    organizationId: string,
    data: OrganizationUpdateCover,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/organizations/${organizationId}/cover`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name GetCompetitorInventoryVisibility
   * @request GET:/organizations/{organizationId}/competitorInventoryVisibility
   * @secure
   * @response `200` `OrganizationCompetitorInventoryVisibilityResponse` OK
   */
  getCompetitorInventoryVisibility = (
    organizationId: string,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationCompetitorInventoryVisibilityResponse, any>({
      path: `/organizations/${organizationId}/competitorInventoryVisibility`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name UpdateCompetitorInventoryVisibility
   * @request PATCH:/organizations/{organizationId}/competitorInventoryVisibility
   * @secure
   * @response `200` `OrganizationCompetitorInventoryVisibilityResponse` OK
   */
  updateCompetitorInventoryVisibility = (
    organizationId: string,
    data: OrganizationUpdateCompetitorInventoryVisibility,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationCompetitorInventoryVisibilityResponse, any>({
      path: `/organizations/${organizationId}/competitorInventoryVisibility`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name GetCommercialConditions
   * @request GET:/organizations/commercialConditions
   * @secure
   * @response `200` `CommercialConditionsResponse` OK
   */
  getCommercialConditions = (params: RequestParams = {}) =>
    this.request<CommercialConditionsResponse, any>({
      path: `/organizations/commercialConditions`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name UpdateCommercialConditions
   * @request PATCH:/organizations/commercialConditions
   * @secure
   * @response `200` `CommercialConditionsResponse` OK
   */
  updateCommercialConditions = (
    data: CommercialConditionsRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommercialConditionsResponse, any>({
      path: `/organizations/commercialConditions`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name DownloadOrganizationDocuments
   * @summary Download Organization Documents
   * @request GET:/organizations/{organizationId}/documents
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadOrganizationDocuments = (
    organizationId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/organizations/${organizationId}/documents`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name DownloadOrganizationDocument
   * @summary Download Organization Document
   * @request GET:/organizations/{organizationId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadOrganizationDocument = (
    organizationId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/organizations/${organizationId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name DeleteOrganizationDocument
   * @summary Delete Organization Document
   * @request DELETE:/organizations/{organizationId}/documents/{documentId}
   * @secure
   * @response `200` `OrganizationResponse` OK
   */
  deleteOrganizationDocument = (
    organizationId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationResponse, any>({
      path: `/organizations/${organizationId}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags public-organization-controller
   * @name ShowOrganization
   * @request GET:/organizations/{id}
   * @secure
   * @response `200` `OrganizationResponse` OK
   */
  showOrganization = (id: string, params: RequestParams = {}) =>
    this.request<OrganizationResponse, any>({
      path: `/organizations/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name ShowSignupRequest
   * @request GET:/organizations/signupRequests/{organizationId}
   * @secure
   * @response `200` `OrganizationDetailsResponse` OK
   */
  showSignupRequest = (organizationId: string, params: RequestParams = {}) =>
    this.request<OrganizationDetailsResponse, any>({
      path: `/organizations/signupRequests/${organizationId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags organization-controller
   * @name OrganizationAlias
   * @request GET:/organizations/alias/{org}
   * @secure
   * @response `200` `OrganizationResponse` OK
   */
  organizationAlias = (org: string, params: RequestParams = {}) =>
    this.request<OrganizationResponse, any>({
      path: `/organizations/alias/${org}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
